import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import CapabilitiesView from "../view/CapabilitiesView.vue";
import CapabilityView from "../view/CapabilityView.vue";
import CapabilityRequestView from "../view/CapabilityRequestView.vue";
import CertificateView from "../view/CertificateView.vue";
import CertificatesView from "../view/CertificatesView.vue";
import CompaniesView from "../view/CompaniesView.vue";
import CompanyView from "../view/CompanyView.vue";
import Documents from "../view/options/Documents.vue";
import Home from "../view/Home.vue";
import EmptyWrapper from "../view/EmptyWrapper.vue";
import IPs from "../view/options/IPs.vue";
import Login from "../view/Login.vue";
import Options from "../view/options/Options.vue";
import Productions from "../view/options/Productions.vue";
import ProjectView from "../view/ProjectView.vue";
import ProjectsView from "../view/ProjectsView.vue";
import User from "../view/options/User.vue";
import UsersTable from "../view/options/UsersTable.vue";

Vue.use(VueRouter);

const TITLE = "Certival";

const routes: RouteConfig[] = [
	{
		name: "Home",
		path: "/",
		component: Home,
		meta: {
			title: TITLE,
		}
	},
	{
		name: "Login",
		path: "/connexion",
		component: Login,
		meta: {
			title: TITLE,
		}
	},
	{
		path: encodeURI("/capacités"),
		component: EmptyWrapper,
		children: [
			{
				name: "Capabilities",
				path: "",
				component: CapabilitiesView,
				meta: {
					title: "Capacités - " + TITLE,
				}
			},
			{
				name: "Capability",
				path: ":id",
				component: CapabilityView,
				props: ({ params }) => ({ id: Number.orDefault(params.id) }),
				meta: {
					title: "Capacité - " + TITLE,
				}
			},
			{
				name: "CapabilityRequest",
				path: "demande/:id",
				component: CapabilityRequestView,
				props: ({ params }) => ({ id: Number.orDefault(params.id) }),
				meta: {
					title: "Demande de Capacité - " + TITLE,
				}
			}
		],
	},
	{
		path: "/clients",
		component: EmptyWrapper,
		children: [
			{
				name: "Companies",
				path: "",
				component: CompaniesView,
				meta: {
					title: "Clients - " + TITLE,
				}
			},
			{
				path: ":id",
				name: "Company",
				component: CompanyView,
				props: ({ params }) => ({ id: Number.orDefault(params.id) }),
				meta: {
					title: "Client - " + TITLE,
				}
			}
		],
	},
	{
		path: "/projets",
		component: EmptyWrapper,
		children: [
			{
				name: "Projects",
				path: "",
				component: ProjectsView,
				meta: {
					title: "Projets - " + TITLE,
				}
			},
			{
				name: "Project",
				path: ":id",
				component: ProjectView,
				props: ({ params }) => ({ id: Number.orDefault(params.id) }),
				meta: {
					title: "Projet - " + TITLE,
				}
			}
		],
	},
	{
		path: "/certificats",
		component: EmptyWrapper,
		children: [
			{
				name: "Certificates",
				path: "",
				component: CertificatesView,
				meta: {
					title: "Certificats - " + TITLE,
				}
			},
			{
				name: "Certificate",
				path: ":id",
				component: CertificateView,
				props: ({ params }) => ({ id: Number.orDefault(params.id) }),
				meta: {
					title: "Certificat - " + TITLE,
				}
			}
		],
	},
	{
		name: "Options",
		path: "/options",
		component: Options,
		meta: {
			title: "Options - " + TITLE,
		}
	},
	{
		name: "Documents",
		path: "/options/bibliotheque",
		component: Documents,
		meta: {
			title: "Bibliothèque - " + TITLE,
		}
	},
	{
		name: "IPs",
		path: "/options/ips",
		component: IPs,
		meta: {
			title: "IPs - " + TITLE,
		}
	},
	{
		name: "Productions",
		path: "/options/productions",
		component: Productions,
		meta: {
			title: "Productions - " + TITLE,
		}
	},
	{
		path: "/options/utilisateurs",
		component: EmptyWrapper,
		children: [
			{
				name: "Users",
				path: "",
				component: UsersTable,
				meta: {
					title: "Utilisateurs - " + TITLE,
				}
			},
			{
				name: "User",
				path: ":id",
				component: User,
				props: ({ params }) => ({ id: Number.orDefault(params.id) }),
				meta: {
					title: "Utilisateur - " + TITLE,
				}
			}
		],
	},
];

export const router = new VueRouter({
	routes,
	mode: "history",
	scrollBehavior(to, from, savedPosition) {
		return savedPosition || { x: 0, y: 0 };
	}
});

router.beforeEach((to, from, next) => {
	const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);
	document.title = nearestWithTitle?.meta.title || TITLE;
	next();
})
